import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  GetWalletTransactionsOutputDto,
  WalletTransactionType,
} from '../../../models/wallet/dto/wallet-admin.dto';

export const GET_WALLET_TRANSACTIONS_QUERY_KEY = (
  userId: string,
  page?: number,
  type?: WalletTransactionType,
) => ['wallet', 'admin', 'transactions', userId, page, type];

export const useGetWalletTransactions = (
  userId: string,
  params: { page?: number; limit?: number; type?: WalletTransactionType } = {},
) => {
  const client = useApiClient();

  return useQuery({
    queryKey: GET_WALLET_TRANSACTIONS_QUERY_KEY(userId, params.page, params.type),
    queryFn: async () => {
      const queryParams = new URLSearchParams();
      if (params.page != null) queryParams.append('page', params.page.toString());
      if (params.limit != null) queryParams.append('limit', params.limit.toString());
      if (params.type) queryParams.append('type', params.type);

      const qs = queryParams.toString();
      return client.fetchApi<GetWalletTransactionsOutputDto, {}>({
        endpoint: `wallet/admin/transactions/${userId}${qs ? '?' + qs : ''}`,
        method: 'GET',
      });
    },
    keepPreviousData: true,
    enabled: Boolean(userId),
    staleTime: 30_000,
  });
};
